import { useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";

export interface PlanFeature {
  title: string;
  description: string;
}

export interface PricingPlanDetails {
  maxStrategyDeployments: number;
  maxScannerDeployments: number;
  allowedEnvs: string[];
  allowedTimeframes: string[];
  allowedAssetClasses: string[];
  key_points: string[];
  features: PlanFeature[];
}

export const useGetMainPricingPlanDetails = (plan: string) => {
  return useQuery({
    queryKey: ["pricingPlanDetails", plan],
    queryFn: async () => {
      const response = await baseApi.get<PricingPlanDetails>(
        `/get_main_pricing_plan_details?plan=${plan}`,
      );
      return response.data;
    },
    enabled: !!plan,
  });
};
